import React, { useState } from 'react';
import Header from '../../component/header';
import '../../css/NftMarketDetail.css';
import check_blue from '../../assets/icons/check_blue.svg';
import share_white from '../../assets/icons/share_white.svg';
import eth_ico from '../../assets/icons/eth_ico.svg';
import eth_ico_big from '../../assets/icons/eth_big.svg';
import logo_ico_big from '../../assets/icons/logo_big.svg';
import clock from '../../assets/icons/clock.svg';
import Countdown from '../../component/countdown';
import MarketTabBox from '../../component/MarketTabBox';
import roll from '../../assets/icons/roll.svg';
import graph from '../../assets/icons/graph.svg';
import link from '../../assets/icons/link.svg';
import lineheart from '../../assets/icons/lineheart.svg';
import siba from '../../assets/duman_siba_BGBG.png';
import StakeModal from '../../component/StakeModal';
import { useRecoilValue } from 'recoil';
import { translatedText } from '../../recoil-states/language-state';
const NftmarketDetail = () => {
	const [tabValue, setTabValue] = useState('Properties');
	const [modalVisible, setModalVisible] = useState(false);
	const textData = useRecoilValue(translatedText);
	const _setModalVisible = bool => {
		setModalVisible(bool);
	};

	return (
		<div id='NftMarket'>
			<Header colortype={''} />
			{/* modal 임시 */}
			<StakeModal
				modalVisible={modalVisible}
				_setModalVisible={_setModalVisible}
			/>
			<div className='market_container col'>
				<div className='market_container_inner_left col-5'>
					<div className='market_container_inner_left_topBox'>
						<div className='left_topText'>
							<p className='konnect_world'>
								Konnect World
								<img
									src={check_blue}
									style={{ marginLeft: '5px' }}
								/>
							</p>
							<p className='Owned'>
								Owned by <b>Konnect</b>
								<a>
									<img
										src={share_white}
										style={{ marginLeft: '5px' }}
									/>
								</a>
							</p>
						</div>
						<div className='price_box'>
							<p className='price_header'>DUMAN #01</p>
							<div className='price_inner'>
								<div className='price_inner_1floor'>
									<div className='_1floor_left'>
										<p>Price</p>
									</div>
									<div className='_1floor_right'>
										<p>Top Offer</p>
										<img
											src={eth_ico}
											style={{
												marginLeft: '5px',
												marginRight: '5px',
											}}
										/>
										<p className='_1floor_price'>1.3</p>
										<hr />
										<p>Last Price</p>
										<img
											src={eth_ico}
											style={{
												marginLeft: '5px',
												marginRight: '5px',
											}}
										/>
										<p className='_1floor_price'>1.2</p>
									</div>
								</div>
								<div className='price_inner_2floor'>
									<img
										src={eth_ico_big}
										style={{ margin: '10px 10px' }}
									/>
									<p>
										<strong style={{ marginRight: '10px' }}>
											1.2
										</strong>
										($3,000)
									</p>
								</div>
								<div className='price_inner_3floor'>
									<img
										src={logo_ico_big}
										style={{ margin: '10px 10px' }}
									/>
									<p>
										<strong style={{ marginRight: '10px' }}>
											52.4
										</strong>
										($2,850)<b>5% off</b>
									</p>
								</div>
								<div className='price_inner_4floor'>
									<p>
										If you make a payment with KCT, You can
										save <b>5</b>%!
									</p>
								</div>
								{/* price inner */}
							</div>
							{/* price box */}
						</div>
						<div className='sale_timeBox'>
							<Countdown />
							<div className='timeBox_text'>
								<img src={clock} />
								<p>
									Sale end on May 10, 2022 at 10:20 am GMT +9{' '}
								</p>
							</div>
						</div>
						<div className='sale_btnBox'>
							<button
								onClick={() => {
									setModalVisible(!modalVisible);
								}}
							>
								<p>Buy now</p>
							</button>
							<button>
								<p>Offer</p>
							</button>
						</div>
					</div>
					<div className='tabBox'>
						<ul>
							<li
								className={
									tabValue === 'Properties' ? 'active' : ''
								}
								onClick={() => {
									setTabValue('Properties');
								}}
							>
								Properties
							</li>
							<li
								className={
									tabValue === 'Description' ? 'active' : ''
								}
								onClick={() => {
									setTabValue('Description');
								}}
							>
								Description
							</li>
							<li
								className={
									tabValue === 'Activity' ? 'active' : ''
								}
								onClick={() => {
									setTabValue('Activity');
								}}
							>
								Activity
							</li>
						</ul>
						<div className='tabNameBox'>
							<span>{tabValue}</span>
						</div>
						<MarketTabBox />
						<MarketTabBox
							itemType='Jarket'
							itemName='Louis Vuitton'
							traitValue='3'
						/>
						<MarketTabBox
							itemType='Shoes'
							itemName='Nike jordan1 offwhite'
							traitValue='1'
						/>
						<MarketTabBox
							itemType='Eye'
							itemName='Gucci Sunglasses'
							traitValue='5'
						/>
						<MarketTabBox
							itemType='Top'
							itemName='Balenciaga'
							traitValue='1'
						/>
						<MarketTabBox
							itemType='Pants'
							itemName='Rick Owens'
							traitValue='3'
						/>
						<MarketTabBox
							itemType='Watch'
							itemName='Rolex Submariner Date'
							traitValue='2'
						/>
						<MarketTabBox
							itemType='Ear'
							itemName='Chrome Hearts'
							traitValue='9'
						/>
						<div className='item_info_container'>
							<div className='item_info_1floor'>
								<div className='item_info_inner'>
									<span>Token ID</span>
									<p>0000</p>
								</div>
							</div>
							<div className='item_info_2floor'>
								<div className='item_info_inner'>
									<span>Contract</span>
									<p>0x...309e</p>
								</div>
							</div>
							<div className='item_info_3floor'>
								<div className='item_info_inner'>
									<span>Blockchain</span>
									<p>Ethereum</p>
								</div>
							</div>
							<div className='item_info_4floor'>
								<div className='item_info_inner'>
									<span>Token Standard</span>
									<p>ERC721</p>
								</div>
							</div>
							<div className='item_info_5floor'>
								<div className='item_info_inner'>
									<span>Creator Royalties</span>
									<p>5%</p>
								</div>
							</div>
						</div>
					</div>
					{/* inner_left */}
				</div>
				<div className='market_container_inner_right col-7'>
					<div className='market_inner_right_topBox'>
						<ul>
							<li>
								<img src={roll} />
							</li>
							<li>
								<img src={graph} />
							</li>
							<li>
								<img src={link} />
							</li>
							<li>
								<img src={lineheart} />
							</li>
						</ul>
					</div>
					<div className='market_inner_right_itemBox'>
						<img src={siba} />
					</div>
				</div>
			</div>
		</div>
	);
};
export default NftmarketDetail;
